// src/lib/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInWithPopup,
  signInWithRedirect,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAA8hNkOWxWC80lYo6IboEDspnu6FI-AjA",
  authDomain: "innofoot-87589.firebaseapp.com",
  projectId: "innofoot-87589",
  storageBucket: "innofoot-87589.firebasestorage.app",
  messagingSenderId: "261926533691",
  appId: "1:261926533691:web:f7dd2085562d6bb35a7a1e",
  measurementId: "G-7JPL9F00KZ",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// ✅ Blijft ingelogd na refresh (1x instellen)
setPersistence(auth, browserLocalPersistence).catch(() => {});

/* =========================
   Providers
   ========================= */

// Google
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Apple
export const appleProvider = new OAuthProvider("apple.com");
// (optioneel) scopes:
// appleProvider.addScope("email");
// appleProvider.addScope("name");

/* =========================
   Sign-in helpers
   ========================= */

export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

// Apple via popup (werkt meestal in Chrome/Edge)
export function signInWithApple() {
  return signInWithPopup(auth, appleProvider);
}

// Apple via redirect (handig voor Safari / popup blockers)
export function signInWithAppleRedirect() {
  return signInWithRedirect(auth, appleProvider);
}